import { Button } from "@mui/material";
import React from "react";
import CustomBotIcon from "../../../app/assets/custom-icons/CustomBotIcon";

const ButtonBot = ({ img, icon, iconText, text, onOpen, ...props }) => {
  return (
    <>
      <div className="flex items-center space-x-4">
        <div className="w-1/3 flex items-center">
          <CustomBotIcon className="w-20 h-20" shadows={false} />
        </div>

        <div className="w-2/3 flex flex-col max-h-32 overflow-auto">
          <p className="text-xs">{text}</p>
        </div>
      </div>
      <Button {...props} onClick={onOpen} variant="outlined" startIcon={icon}>
        {iconText}
      </Button>
    </>
  );
};

export default ButtonBot;
